import { z } from 'zod';
import { uuid } from './fields';
import { AiSuggestionModel } from './master-list-items';
import { TripItemWithLabels } from './trip-items';

/**
 * Cross-list linked items (trip phase 2). Within a trip, the same real-world
 * thing often lands on two different lists. An AI scan clusters same-thing items
 * across DIFFERENT lists; the user confirms each cluster and picks a controlling
 * copy. Linking is also available manually from an item's detail sheet.
 */

/** POST /api/trips/:tripId/find-duplicates body. */
export const FindTripDuplicatesInput = z.object({
  model: AiSuggestionModel.default('gpt_fast'),
});
export type FindTripDuplicatesInput = z.infer<typeof FindTripDuplicatesInput>;

/** A suggested cluster of trip items judged to be the same thing across lists. */
export const TripDuplicateGroup = z.object({
  items: z.array(TripItemWithLabels).min(2),
  /** Default controller = the first item; the user can re-pick before linking. */
  suggestedControllerId: uuid(),
});
export type TripDuplicateGroup = z.infer<typeof TripDuplicateGroup>;

export const FindTripDuplicatesResult = z.object({
  groups: z.array(TripDuplicateGroup),
});
export type FindTripDuplicatesResult = z.infer<typeof FindTripDuplicatesResult>;

/** POST /api/trips/:tripId/items/:controllerId/link body. */
export const LinkTripItemsInput = z.object({
  linkedItemIds: z.array(uuid()).min(1),
});
export type LinkTripItemsInput = z.infer<typeof LinkTripItemsInput>;
